import { render, staticRenderFns } from "./CoverDetails.vue?vue&type=template&id=18301d7c&scoped=true"
import script from "./CoverDetails.vue?vue&type=script&lang=js"
export * from "./CoverDetails.vue?vue&type=script&lang=js"
import style0 from "./CoverDetails.vue?vue&type=style&index=0&id=18301d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18301d7c",
  null
  
)

/* custom blocks */
import block0 from "./CoverDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports